var Shopify = Shopify || {};

Shopify.formatMoney = (currency, amount) => {
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currency,
  }).format(amount);
};

// Check if we need to open cart after page load
document.addEventListener('DOMContentLoaded', () => {
  const shouldOpenCart = sessionStorage.getItem('openCartAfterRedirect');
  if (shouldOpenCart === 'true') {
    sessionStorage.removeItem('openCartAfterRedirect');
    setTimeout(() => {
      if (typeof toggleCart === 'function') {
        toggleCart();
      }
    }, 100);
  }
});